import React from "react";

import { useVolatileCallback } from "../../hooks/useVolatile";

import Button, { ButtonProps } from "./Button";

const CheckboxButton = ({
  checked,
  onCheckedChange,
  onClick,
  ...props
}: ButtonProps & {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}) => {
  const onClickInternal = useVolatileCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      onClick?.(e);
      onCheckedChange?.(!checked);
    },
  );

  return (
    <Button variant="plain" onClick={onClickInternal} {...props}>
      <input
        type="checkbox"
        checked={checked}
        disabled={props.disabled}
        readOnly
      />{" "}
      {props.children}
    </Button>
  );
};

export default CheckboxButton;
